<template>
    <div class="bo-image-category-banner">
        <div class="banner-title">
            {{ bannerTitle }}
        </div>
        <div class="category-section">
            <div
                v-for="category in categories"
                :key="category.index"
                class="category-slide"
            >
                <a
                    :class="['category-content']"
                    :href="category.link"
                    target="_blank"
                >
                    <img
                        :src="category.image || defaultImage"
                        class="image-block"
                    />

                    <div class="text-block theme-primary-bg-color">
                        <div class="title">{{ category.title }}</div>
                        <span class="category-url">View More</span>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        bannerTitle: {
            type: String,
            default: null,
        },
        categories: {
            type: Array,
            default: "",
        },
    },
    data() {
        return {
            defaultImage: "/images/img-product.svg",
        };
    },
};
</script>
